import {
  MyDocumentsSettingsPage,
  MyDocumentsUploadDocumentsPage,
  MyDocumentsUserFilesPage,
  MyDocumentsViewDocumentsPage,
} from "my-documents/pages";

export const myDocumentsUploaderDocumentsPageRoutePath =
  "/my-documents/upload-documents";
export const myDocumentsViewDocumentsPageRoutePath =
  "/my-documents/view-documents";
export const myDocumentsUserFilesPageRoutePath =
  "/my-documents/user-files/:employee/:contract";
export const myDocumentsSettingsPageRoutePath = "/my-documents/settings";

export const buildMyDocumentsUserFilesPageRoutePath = ({
  employee,
  contract,
}: {
  employee: string;
  contract: string;
}) => {
  return `/my-documents/user-files/${employee}/${contract}`;
};

export const myDocumentsRoutes = [
  {
    id: "myDocumentsUploaderDocumentsPageRoute",
    path: myDocumentsUploaderDocumentsPageRoutePath,
    exact: true,
    private: true,
    component: MyDocumentsUploadDocumentsPage,
    roles: ["MyDocuments.uploader"],
  },
  {
    id: "myDocumentsViewDocumentsPageRoute",
    path: myDocumentsViewDocumentsPageRoutePath,
    exact: true,
    private: true,
    component: MyDocumentsViewDocumentsPage,
    roles: ["MyDocuments.viewer"],
  },
  {
    id: "myDocumentsUserFilesPageRoute",
    path: myDocumentsUserFilesPageRoutePath,
    exact: true,
    private: true,
    component: MyDocumentsUserFilesPage,
    roles: ["MyDocuments.uploader", "MyDocuments.viewer"],
  },
  {
    id: "myDocumentsSettingsPageRoute",
    path: myDocumentsSettingsPageRoutePath,
    exact: true,
    private: true,
    component: MyDocumentsSettingsPage,
    roles: ["MyHR.admin"],
  },
];
